import React from 'react';
import { Card } from 'react-bootstrap';
import { Container } from 'react-bootstrap';
import { Row, Col } from 'react-bootstrap';
// import { Card, CardBody, CardText, CardTitle } from 'react-bootstrap';
import './Supports.css';

import suppsensorbg from '../images/PageImg/SupportSensor-page-bg.jpg'
import HeaderSlide from '../components/HeaderSlide'
import { SuppSensorSS } from "../assets/SupportsData";
import { SuppSensorSM } from "../assets/SupportsData";
import { SuppSensorMM } from "../assets/SupportsData";
import { SuppSensorML } from "../assets/SupportsData";
import { SuppSensorLL } from "../assets/SupportsData";
import { SuppSensorXL } from "../assets/SupportsData";

import SuppSensorSSImg from '../images/SupportImg/SuppSensorSS.jpg';
import SuppSensorSMImg from '../images/SupportImg/SuppSensorSM.jpg';
import SuppSensorMMImg from '../images/SupportImg/SuppSensorMM.jpg';
import SuppSensorMLImg from '../images/SupportImg/SuppSensorML.jpg';
import SuppSensorLLImg from '../images/SupportImg/SuppSensorLL.jpg';
import SuppSensorXLImg from '../images/SupportImg/SuppSensorXL.jpg';

import { GoTopBtn } from '../components/GoTopBtn';

function SupportSensor() {
  // console.log("get into SupportSensor()");
  return (
    /* Support / Sensor Category */
    <div className='support-page' >
      <div className='supportheader'
        style={{ backgroundImage: `url(${suppsensorbg})`, height: "auto" }} >
        <HeaderSlide text={'Support / Sensor'} />
        <h4 className='text-light'>&nbsp;images/PageImg/SupportSensor-page-bg.jpg</h4>
      </div>

      {/* Support / Small Size Sensor */}
      <section id='suppsensorss' className='suppsensor bg-info-subtle text-dark my-4'>
        <Container>
          <h2 className='title-holder fs-1 fw-bold text-primary'>Support / Small Size Sensor</h2>
          <Row>
            <Col lg={6} className='d-flex flex-column justify-content-center'>
              <img src={SuppSensorSSImg} className='mt-5 mt-lg-0' alt="" />
              <h5>images/SupportImg/SuppSensorSS.jpg</h5>
            </Col>
            <Col lg={6} className='d-flex flex-column justify-content-around'> {
              SuppSensorSS.map((sensor) => (
                <Row key={sensor.id}>
                  <Card className='bg-info-subtle border-1 p-0 m-0'>
                    <Card.Body className='d-flex justify-content-center'>
                      <Card.Title className='fs-2 text-primary px-3 my-1'> {sensor.name} </Card.Title>
                      <Card.Text className='fs-4'>
                        <a href={`/ListingSensorsBySize/${sensor.size}`} className='btn suppbtn-success'> {sensor.text} </a>
                      </Card.Text>
                    </Card.Body>
                  </Card>
                </Row>
              ))
            } </Col>
          </Row>
        </Container>
      </section>

      {/* Support / Small-Miduim Size Sensor */}
      <section id='suppsensorsm' className='suppsensor bg-primary-subtle text-dark my-4'>
        <Container>
          <h2 className='title-holder fs-1 fw-bold text-success'>Support / Small-Miduim Size Sensor</h2>
          <Row>
            <Col lg={6} className='d-flex flex-column justify-content-around'> {
              SuppSensorSM.map((sensor) => (
                <Row key={sensor.id}>
                  <Card className='bg-primary-subtle border-1 p-0 m-0'>
                    <Card.Body className='d-flex justify-content-center'>
                      <Card.Title className='fs-2 text-success px-3 my-1'> {sensor.name} </Card.Title>
                      <Card.Text className='fs-4'>
                        <a href={`/ListingSensorsBySize/${sensor.size}`} className='btn suppbtn-primary'> {sensor.text} </a>
                      </Card.Text>
                    </Card.Body>
                  </Card>
                </Row>
              ))
            } </Col>
            <Col lg={6} className='d-flex flex-column justify-content-center'>
              <img src={SuppSensorSMImg} className='mt-5 mt-lg-0' alt="" />
              <h5>images/SupportImg/SuppSensorSM.jpg</h5>
            </Col>
          </Row>
        </Container>
      </section>

      {/* Support / Miduim Size Sensor */}
      <section id='suppsensormm' className='suppsensor bg-info-subtle text-dark my-4'>
        <Container>
          <h2 className='title-holder fs-1 fw-bold text-primary'>Support / Miduim Size Sensor</h2>
          <Row>
            <Col lg={6} className='d-flex flex-column justify-content-center'>
              <img src={SuppSensorMMImg} className='mt-5 mt-lg-0' alt="" />
              <h5>images/SupportImg/SuppSensorMM.jpg</h5>
            </Col>
            <Col lg={6} className='d-flex flex-column justify-content-around'> {
              SuppSensorMM.map((sensor) => (
                <Row key={sensor.id}>
                  <Card className='bg-info-subtle border-1 p-0 m-0'>
                    <Card.Body className='d-flex justify-content-center'>
                      <Card.Title className='fs-2 text-primary px-3 my-1'> {sensor.name} </Card.Title>
                      <Card.Text className='fs-4'>
                        <a href={`/ListingSensorsBySize/${sensor.size}`} className='btn suppbtn-success'> {sensor.text} </a>
                      </Card.Text>
                    </Card.Body>
                  </Card>
                </Row>
              ))
            } </Col>
          </Row>
        </Container>
      </section>

      {/* Support / Miduim-Large Size Sensor */}
      <section id='suppsensorml' className='suppsensor bg-primary-subtle text-dark my-4'>
        <Container>
          <h2 className='title-holder fs-1 fw-bold text-success'>Support / Miduim-Large Size Sensor</h2>
          <Row>
            <Col lg={6} className='d-flex flex-column justify-content-around'> {
              SuppSensorML.map((sensor) => (
                <Row key={sensor.id}>
                  <Card className='bg-primary-subtle border-1 p-0 m-0'>
                    <Card.Body className='d-flex justify-content-center'>
                      <Card.Title className='fs-2 text-success px-3 my-1'> {sensor.name} </Card.Title>
                      <Card.Text className='fs-4'>
                        <a href={`/ListingSensorsBySize/${sensor.size}`} className='btn suppbtn-primary'> {sensor.text} </a>
                      </Card.Text>
                    </Card.Body>
                  </Card>
                </Row>
              ))
            } </Col>
            <Col lg={6} className='d-flex flex-column justify-content-center'>
              <img src={SuppSensorMLImg} className='mt-5 mt-lg-0' alt="" />
              <h5>images/SupportImg/SuppSensorML.jpg</h5>
            </Col>
          </Row>
        </Container>
      </section>

      {/* Support / Large Size Sensor */}
      <section id='suppsensorll' className='suppsensor bg-info-subtle text-dark my-4'>
        <Container>
          <h2 className='title-holder fs-1 fw-bold text-primary'>Support / Large Size Sensor</h2>
          <Row>
            <Col lg={6} className='d-flex flex-column justify-content-center'>
              <img src={SuppSensorLLImg} className='mt-5 mt-lg-0' alt="" />
              <h5>images/SupportImg/SuppSensorLL.jpg</h5>
            </Col>
            <Col lg={6} className='d-flex flex-column justify-content-around'> {
              SuppSensorLL.map((sensor) => (
                <Row key={sensor.id}>
                  <Card className='bg-info-subtle border-1 p-0 m-0'>
                    <Card.Body className='d-flex justify-content-center'>
                      <Card.Title className='fs-2 text-primary px-3 my-1'> {sensor.name} </Card.Title>
                      <Card.Text className='fs-4'>
                        <a href={`/ListingSensorsBySize/${sensor.size}`} className='btn suppbtn-success'> {sensor.text} </a>
                      </Card.Text>
                    </Card.Body>
                  </Card>
                </Row>
              ))
            } </Col>
          </Row>
        </Container>
      </section>

      {/* Support / Extra-Large Size Sensor */}
      <section id='suppsensorxl' className='suppsensor bg-primary-subtle text-dark my-4'>
        <Container>
          <h2 className='title-holder fs-1 fw-bold text-success'>Support / Extra-Large Size Sensor</h2>
          <Row>
            <Col lg={6} className='d-flex flex-column justify-content-around'> {
              SuppSensorXL.map((sensor) => (
                <Row key={sensor.id}>
                  <Card className='bg-primary-subtle border-1 p-0 m-0'>
                    <Card.Body className='d-flex justify-content-center'>
                      <Card.Title className='fs-2 text-success px-3 my-1'> {sensor.name} </Card.Title>
                      <Card.Text className='fs-4'>
                        <a href={`/ListingSensorsBySize/${sensor.size}`} className='btn suppbtn-primary'> {sensor.text} </a>
                      </Card.Text>
                    </Card.Body>
                  </Card>
                </Row>
              ))
            } </Col>
            <Col lg={6} className='d-flex flex-column justify-content-center'>
              <img src={SuppSensorXLImg} className='mt-5 mt-lg-0' alt="" />
              <h5>images/SupportImg/SuppSensorXL.jpg</h5>
            </Col>
          </Row>
        </Container>
      </section>
      <div> < GoTopBtn /> </div>
    </ div>
  )
}

export default SupportSensor;

/*
<header className='mt-5'>
  <Container className='h-100 d-flex align-items-center justify-content-center'>
    <h1 className='text-light'>Support / Sensor</h1>
  </Container>
</header>
*/
/*
<Col lg={6} className='d-flex flex-column justify-content-center'>
  <img src={SuppSensorSSImg} className='mt-5 mt-lg-0' alt="" />
  // <img src={SuppSensor} className='img-fluid w-80' style={{ height: '85vh' }} />
  // <img src={SuppSensorXLImg} className='mt-5' style={{ height: '45vh' }} alt="" />
  <h5>images/SupportImg/SuppSensorSS.jpg</h5>
</Col>
*/

/*
<Row key={sensor.id}>
  <Card className='bg-info-subtle border-1 p-0 m-0'>
    <Card.Body className='d-flex justify-content-center'>
      <Card.Title className='fs-2 text-primary px-3 my-1'> {sensor.name} </Card.Title>
      // <Card.Title className='fs-2 text-success p-1 mx-2'> {sensor.name} </Card.Title>
      <Card.Text className='fs-4'>
        // <Card.Text className='text-center fs-4'>
        <a href={`/ListingSensorsBySize/${sensor.size}`} className='btn suppbtn-success'> {sensor.text} </a>
      </Card.Text>
    </Card.Body>
  </Card>
</Row>
*/
